import axios from 'axios';
const HOSTAPI = process.env.REACT_APP_BASE_URL;

export const fetchPollCount = async (pollId: string) => {
    try {
        const response = await axios.get(`${HOSTAPI}/poll/${pollId}/answered-count`);
        if (response.data.status === 'success') {
            return response.data.data;
        } else {
            throw new Error('Failed to fetch slides');
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
};
